import { SVGAttributes, CSSProperties } from 'react';
import { CUSTOM_SVG_ICON_CLASS, NEGATIVE_COLOR_CSS_VARIABLE } from './const';
import { IsNegativeProps } from './types';

type SvgIconArgs = IsNegativeProps &
  Pick<
    SVGAttributes<SVGSVGElement>,
    'width' | 'height' | 'viewBox' | 'clipPath'
  > & {
    iconId: string;
    left?: string;
    top?: string;
    scale?: { x: number; y: number };
    style?: CSSProperties;
    color?: string;
  };
const SvgIcon = ({
  iconId,
  left,
  top,
  width,
  height,
  scale,
  viewBox = '0 0 80 80',
  style,
  color,
  isNegative,
}: SvgIconArgs) => {
  const scaleString =
    typeof scale !== 'undefined' ? `scale(${scale.x}, ${scale.x})` : '';
  const elementStyle = isNegative
    ? { ...(style ?? {}), [NEGATIVE_COLOR_CSS_VARIABLE]: 'none' }
    : style;
  return (
    <svg
      className={CUSTOM_SVG_ICON_CLASS}
      style={elementStyle}
      viewBox={viewBox}
      x={left}
      y={top}
      width={width}
      height={height}
    >
      <use
        transform={scaleString}
        href={`#${iconId}`}
        color={color}
        fill={color}
      />
    </svg>
  );
};

export { SvgIcon };
